export interface ProjectionDetails {
  placeholderAccounts: PlaceholderAccount[];
}

export interface PlaceholderAccount {
  accountNameToDisplay: string;
  accountNumberToDisplay: string;
  accountTypeToDisplay: string;
  totalAmountToDisplay: number;
  accountId: ProspectAccount;
}

export enum ProspectAccount {
  PROSPECT_ACCOUNT_NAME = 'PROSPECT-PLACEHOLDER-ACCOUNT', // use in ALL GC flows (ONA/TOA/ROLO) where the seed money is going into a new account
}
